import React from 'react';
import { motion } from 'framer-motion';
import advantageImg from '../assets/2.jpg'; 
import { FaArrowRight } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const SuperiourCustomerServices = () => {
  const services = [
    { title: "Easy to install", description: "Our easy-to-install elevators are designed for quick setup and minimal disruption. Compact and efficient, they provide seamless vertical mobility while fitting effortlessly into any space.", color: "#228B22" },
    { title: "Minimal maintenance", description: "A unique maintenance plan for each piece of equipment, with options for standard, plus, or premium service levels. WVT Elevators includes maintenance audits, help with maintenance, and how passengers can communicate with WVT Elevators in an emergency.", color: "#1E90FF" },
    { title: "Space friendly", description: "We provide space-efficient, customizable lifts designed to fit your building perfectly. Combining functionality with aesthetics, our tailored solutions ensure optimal performance and seamless integration into any space.", color: "#228B22" },
    { title: "Self supporting", description: "Self-supporting elevators are compact, space-efficient solutions that don’t require a separate shaft or machine room. Easy to install, they offer seamless vertical transportation while blending effortlessly into any building design.", color: "#1E90FF" },
    { title: "Home lift models", description: "Our home lift models are compact, stylish, and customizable. Designed for convenience and efficiency, they enhance accessibility while seamlessly blending with your home’s interior design.", color: "#228B22" },
    { title: "Eco-friendly system", description: "WVT Elevators doors follow a plug and play system and does not require any types of harmful oils. Lubricants or gases for operation, thus is an eco-friendly option.", color: "#1E90FF" },
  ];

  const advantages = [
    "Energy-Efficient Design",
    "Smart Elevator System",
    "Proprietary Technologies",
    "Strong Company Values",
    "Modernization and Upgrades",
    "Absolute SAFETY! ASME Certified",
    "Minimal Maintenance",
    "Cost-effective products and services",
    "Eco-friendly elevator. GO GREEN",
    "Self-Supporting Home Elevator",
    "Space saving solution for your Home",
    "Providing 3 kinds of air-driven Home Elevator Model"
  ];

  const containerVariants = {
    hidden: {},
    visible: { transition: { staggerChildren: 0.25 } },
  };

  const cardVariants = {
    hidden: { y: 80, opacity: 0 },
    visible: { y: 0, opacity: 1, transition: { duration: 0.7, ease: "easeOut" } },
  };

  const textVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: { y: 0, opacity: 1, transition: { duration: 0.6, ease: "easeOut" } },
  };

  return (
    <section className="w-full">
      {/* Superior Customer Services */}
      <section className="w-full px-6 py-12">
        <div className="text-center mb-12 max-w-7xl mx-auto">
          <h4 className="text-[#228B22] font-semibold mb-2">WHY CHOOSE US</h4>
          <h1 className="text-3xl md:text-4xl font-bold text-gray-800">
            Superior Customer Service
          </h1>
        </div>

        <motion.div
          className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 max-w-7xl mx-auto"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }}
        >
          {services.map((service, index) => (
            <motion.div
              key={index}
              style={{ backgroundColor: service.color }}
              className="p-6 rounded-xl shadow-lg hover:shadow-2xl transition transform hover:-translate-y-2 text-white"
              variants={cardVariants}
            >
              <motion.h2 className="text-xl font-bold mb-2" variants={textVariants}>
                {service.title}
              </motion.h2>
              <motion.p variants={textVariants}>{service.description}</motion.p>
            </motion.div>
          ))}
        </motion.div>
      </section>

      {/* Advantages Section */}
      <section className="w-full -mx-6 py-12">
        <div className="flex flex-col md:flex-row items-stretch gap-4 md:gap-6 max-w-7xl mx-auto">
          {/* Left: Full-cover Image */}
          <div className="md:w-5/12 w-full flex justify-center md:justify-start">
            <img
              src={advantageImg}
              alt="Advantage"
              className="rounded-lg shadow-lg w-full h-full object-cover"
              style={{ minHeight: "350px" }}
            />
          </div>

          {/* Right: Headings + Bullets + Contact Button */}
          <div className="md:w-7/12 w-full flex flex-col justify-between bg-[#00ffff] p-6 rounded-lg text-#070505 h-full">
            <div>
              <h2 className="text-3xl font-bold mb-2">Advantage Of WVT</h2>

             <ul className="list-disc list-inside space-y-2 mb-6">
                {advantages.map((item, index) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
            </div>

            <motion.button
              whileHover={{ scale: 1.05, boxShadow: "0px 5px 15px rgba(0,0,0,0.3)" }}
              whileTap={{ scale: 0.95 }}
              className="bg-white text-[#1E90FF] px-6 py-3 rounded-md font-semibold flex items-center gap-2 shadow-md hover:bg-gray-100 transition w-max mt-4"
            >
              <Link to={`/contact`}> Contact  <FaArrowRight /></Link>
              
            </motion.button>
          </div>
        </div>
      </section>
    </section>
  );
};

export default SuperiourCustomerServices;
